const BASE_URL = import.meta.env.VITE_API_BASE_URL || '/v1'

async function adminFetch<T>(
  path: string,
  adminKey: string,
  options: RequestInit = {},
): Promise<T> {
  const response = await fetch(`${BASE_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      adminkey: adminKey,
      ...options.headers,
    },
  })

  if (!response.ok) {
    const error = await response.json().catch(() => ({}))
    throw new Error(error.message || `Admin request failed (${response.status})`)
  }

  if (response.status === 204) return undefined as T
  return response.json()
}

export interface AdminUser {
  id: number
  email: string
  firstName?: string
  lastName?: string
  admin: boolean
  isActive: boolean
  createdAt: string
  updatedAt: string
  metadata: Record<string, unknown>
}

export interface AdminUsersPage {
  items: AdminUser[]
  total: number
  limit: number
  offset: number
}

export const adminApi = {
  verifyKey(adminKey: string) {
    return adminFetch<{ status: string }>('/admin/health', adminKey)
      .then(() => true)
      .catch(() => false)
  },

  signInAs(adminKey: string, email: string) {
    return adminFetch<{ accessToken: string }>('/admin/sign-in-as', adminKey, {
      method: 'POST',
      body: JSON.stringify({ email }),
    })
  },

  triggerWorkerHealth(adminKey: string) {
    return adminFetch<{ jobId: string }>('/admin/workers/health', adminKey, {
      method: 'POST',
    })
  },

  listUsers(adminKey: string, params: { limit?: number; offset?: number } = {}) {
    const qs = new URLSearchParams()
    if (params.limit !== undefined) qs.set('limit', String(params.limit))
    if (params.offset !== undefined) qs.set('offset', String(params.offset))
    const suffix = qs.toString() ? `?${qs}` : ''
    return adminFetch<AdminUsersPage>(`/admin/users${suffix}`, adminKey)
  },
}
